import { Outlet, createRootRoute } from "@tanstack/react-router";
import { Provider } from "react-redux";
import store, { persistor } from "@/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import PrivyProviders from "@/provider/PrivyProvider";
import { createTheme, ThemeProvider } from "@mui/material";
import Layout from "@/components/Layout";
import "@/utils/I18n";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import { chartsCustomizations } from "@/theme/chart";

const inter = "'Inter', sans-serif";

const theme = createTheme({
  palette: {
    mode: "dark",
  },
  typography: {
    fontFamily: [inter, "sans-serif"].join(","),
  },

  components: {
    ...chartsCustomizations,
  },
});

export const Route = createRootRoute({
  component: () => {
    return (
      <>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <PrivyProviders>
              <SmartWalletsProvider>
                <ThemeProvider theme={theme}>
                  <Layout>
                    <Outlet />
                  </Layout>
                </ThemeProvider>
              </SmartWalletsProvider>
            </PrivyProviders>
          </PersistGate>
        </Provider>
      </>
    );
  },
});
